import React, { useState, useEffect } from "react";
import "../../Styles/Modal.css";
import { ImCancelCircle } from "react-icons/im";
import { CircularProgress } from "@mui/material";
import axios from "axios";
import Swal from "sweetalert2";
import ReLoginModal from "../ReLoginModal";
import { toast } from "react-toastify";

interface CustomerBankProps {
  cusID: string;
  getUserId: string;
  setCBank: React.Dispatch<React.SetStateAction<boolean>>;
}

interface Bank {
  _id: string;
  bankName: string;
}

interface Product {
  _id: string;
  name: string;
}

const CustomerBank: React.FC<CustomerBankProps> = ({ cusID, getUserId, setCBank }) => {
  const [banks, setBanks] = useState<Bank[]>([]);
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(false);
  const [reLogin, setReLogin] = useState(false);

  const token = window.localStorage.getItem("token");
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  useEffect(() => {
    queryBanks();
    queryProducts();
  }, []);

  function queryBanks() {
    axios
      .get("https://apibiz.oneflaretech.com/api/settings", { headers })
      .then((res) => {
        setBanks(res.data.data.banks);
      })
      .catch((error) => {
        toast.error(error.response.data.message);
        if (
          error.response.data.message === "jwt expired" ||
          error.response.data.message === "jwt malformed"
        ) {
          setReLogin(true);
        } else {
          setReLogin(false);
        }
      });
  }

  function queryProducts() {
    axios
      .get("https://apibiz.oneflaretech.com/api/inventory", { headers })
      .then((res) => {
        setProducts(res.data.data);
      })
      .catch((error) => {
        toast.error(error.response.data.message);
        if (
          error.response.data.message === "jwt expired" ||
          error.response.data.message === "jwt malformed"
        ) {
          setReLogin(true);
        } else {
          setReLogin(false);
        }
      });
  }

  const [funding, setFunding] = useState({
    amount: "",
    bank: "",
    product: "",
  });

  const handleFundChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFunding((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFundSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const amountInt = parseInt(funding.amount, 10);

    if (amountInt === 0 || isNaN(amountInt)) {
      Swal.fire({
        title: "Error!",
        text: "Amount cannot be zero or empty.",
        icon: "error",
        showCancelButton: false,
        confirmButtonColor: "red",
        confirmButtonText: "Try Again",
      });
      return;
    }

    setLoading(true);

    axios
      .post(
        `https://apibiz.oneflaretech.com/api/customer/${getUserId}/account/`,
        {
          amount: funding.amount,
          product: funding.product,
          bank: funding.bank,
        },
        { headers }
      )
      .then((res) => {
        Swal.fire({
          title: "Success!",
          text: res.data.message,
          icon: "success",
          showCancelButton: false,
          confirmButtonColor: "green",
          confirmButtonText: "Continue",
        });
        setLoading(false);
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      })
      .catch((err) => {
        console.error(err);
        Swal.fire({
          title: "Error!",
          text: err.response.data.message,
          icon: "error",
          showCancelButton: false,
          confirmButtonColor: "red",
          confirmButtonText: "Try Again",
        });
        if (
          err.response.data.message === "jwt expired" ||
          err.response.data.message === "jwt malformed"
        ) {
          setReLogin(true);
        } else {
          setReLogin(false);
        }
        setLoading(false);
      });
  };

  return (
    <div className="modal">
      <div className="catModal">
        <div className="catModalTop">
          <h4>Banks</h4>
          <ImCancelCircle className="catCancel" onClick={() => setCBank(false)} />
        </div>
        {reLogin && <ReLoginModal />}
        <div className="line"></div>
        <form onSubmit={handleFundSubmit} className="invoiceTable">
          <div className="catModalInput branchInput noM">
            <select name="bank" onChange={handleFundChange}>
              <option value="">Select Bank</option>
              {banks.map((bank) => (
                <option key={bank._id} value={bank._id}>
                  {bank.bankName}
                </option>
              ))}
            </select>
            <select name="product" onChange={handleFundChange}>
              <option value="">Select Product</option>
              {products.map((product) => (
                <option key={product._id} value={product._id}>
                  {product.name}
                </option>
              ))}
            </select>
            <input
              type="text"
              placeholder="Amount"
              name="amount"
              value={funding.amount}
              onChange={handleFundChange}
            />
            <div className="crBtn sstest">
              <button type="submit">Create</button>
              {loading && <CircularProgress style={{ color: "#fff", backgroundColor: "transparent", width: "20px", height: "20px" }} />}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CustomerBank;
